import classNames from 'classnames/bind';
import styles from './History.module.scss';
import { Link, NavLink } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import GlobalStateContext from '~/GlobalStateContext ';
import API_URL from '~/config';
import ReactPaginate from "react-paginate";

const cx = classNames.bind(styles);

function History() {
    const [listHistory, setListHistory] = useState([]);
    const [pagination, setPagination] = useState({
        last_page: 0,
        current_page: 1,
        per_page: 20
    });
    const { token, setToken } = useContext(GlobalStateContext);
    const baseToken = localStorage.getItem('access_token');
    const [loading, setLoading] = useState(false);
    const [isAccessible, setIsAccessible] = useState(true);


    const checkAccess = async (func) => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_URL}/admin/check-access`, { function: func }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setIsAccessible(response.data.message === 'Authorized');
        } catch (error) {
            console.error("Access check failed:", error);
            setIsAccessible(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAccess('SendMail');
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchListHistory(1);
    }, []);

    const fetchListHistory = (page) => {
        axios
            .get(`${API_URL}/admin/histories?current_page=${page}`, {
                headers: {
                    Authorization: `Bearer ${token || baseToken}`,
                },
            })
            .then((response) => {
                setListHistory(response.data.histories.data);
                setPagination(response.data.histories)
            })
            .catch((error) => {
                // Handle error
                console.error('Error fetching data:', error);
                if (error.response.status === 401) {
                    setIsAccessible(false);
                }
            });
    };

    const handlePageClick = (page) => {
        fetchListHistory(page.selected + 1)
    }

    const formatDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    if (loading) {
        return <div className={cx('loading')}>Loading...</div>;
    }

    if (!isAccessible) {
        return <div className={cx('error')}> Unauthorized </div>;
    }

    return (
        <div>
            <table className={cx('styled-table')}>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Email</th>
                        <th>Template</th>
                        <th>Subject</th>
                        <th>Created At</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {listHistory?.map((item, index) => {
                        return (
                            <tr key={item.id}>
                                <th>{index + 1}</th>
                                <th>{item.email}</th>
                                <th>{item.template?.template_name}</th>
                                <th>{item.subject?.name}</th>
                                <th>{formatDateTime(item.created_at)}</th>
                                <th style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <button
                                        className={cx('button', item.status === 0 ? 'wait-button' : 'sent-button')}
                                    >
                                        {item.status === 0 ? 'Waitting' : 'Sent'}
                                    </button>
                                </th>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ReactPaginate
                    previousLabel={"← Previous"}
                    nextLabel={"Next →"}
                    pageCount={pagination.last_page}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    pageRangeDisplayed={5}
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                />
            </div>
        </div>
    );
}

export default History;
